export default __webpack_public_path__ + "media/zurb/img/about/bryan/bryan-img2-d5d383b5fa0b44bf77084441d18f008e.png";